import { Col, Row } from "react-bootstrap";
import { Input, Select, DatePicker, Button, Table, Pagination, Modal, message, Spin } from 'antd';
import styles from "./style.module.css"
import { useEffect } from "react";
import { useState } from "react";
import axiosService from "../../utils/axios.service";
import moment from "moment"
import * as convert from "../constant/Convert.helper";
import { fetchAPI } from "../../libs/fetchStrapi"
import { useDebouncedCallback } from 'use-debounce';
import {paymentMethod, statusLead } from "../../enums/pre-order.enum";
import _ from 'lodash';
const { Option } = Select;
const { RangePicker } = DatePicker;

export default function LeadWebsite() {
    const [status, setStatus] = useState(statusLead[0].value)
    const [startDate, setStartDate] = useState(moment(new Date(moment().startOf('week'))).format('YYYY-MM-DD'))
    const [endDate, setEnDate] = useState(moment(new Date(moment().endOf('week'))).format('YYYY-MM-DD'))
    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [limit, setLimit] = useState(10)
    const [page, setPage] = useState(1)
    const [nameFetch, setNameFetch] = useState("")
    const [phoneFetch, setPhoneFetch] = useState("")
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [content, setContent] = useState("")
    const [title, setTitle] = useState("")
    const [dataSelect, setDataSelect] = useState(null)
    const [isLoading, setIsLoading] = useState(true)
    const [total, setTotal] = useState(0)
    const [list, setList] = useState([])
    const [listStaff, setListStaff] = useState([])
    const [loadingStaff, setLoadingStaff] = useState(false)
    const [reload, setReload] = useState(false)

    const columns = [
        {
            title: 'Ngày tạo lead',
            dataIndex: 'created_at',
            key: 'created_at',
            align: "center",
            render: (data) => {
                return (
                    <>
                        <span>{moment(data).format('HH:mm:ss DD-MM-YYYY')}</span>
                    </>
                )
            },
        },
        {
            title: 'Khách hàng',
            key: "name",
            align: "center",
            render: (data) => {
                return (
                    <>
                        <p>Tên: {data.customer_name}</p>
                        <p>SDT: {data.customer_phone}</p>
                    </>
                )
            },
        },
        {
            title: 'Dịch vụ',
            key: "services",
            dataIndex: 'services',
            align: "center",
            render: (data) => {
                return (
                    <>
                        {data.length > 0 ?
                            data.map((x, i) => {
                                return <p key={i}>{i + 1}.{x.label}</p>
                            })
                        : null}
                    </>
                )
            },
        },
        {
            title: 'Người tư vấn',
            key: "assign_for",
            dataIndex: 'assign_for',
            align: "center",
            width: '250px',
            render: (data, x) => {
                return (
                    <Select
                        className="w-100"
                        showSearch
                        defaultValue={data ?? 0}
                        placeholder="Chọn nhân viên"
                        optionFilterProp="children"
                        disabled={data ? true : false }
                        loading={loadingStaff}
                        onChange={(e) => {handleValidate(x.status, e, x, 1)}}
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        {listStaff.map((x,y) => {
                            return <Option value={x.id} key={y} disabled={x.disable}>{x.name}</Option>
                        })}
                    </Select>
                )
            },
        },
        {
            title: 'Chức năng',
            dataIndex: 'status',
            align: "center",
            key: "action",
            width: "10%",
            render: (data, x) => {
                let index = _.findIndex(statusLead, function(o) { return o.value == data; });
                return (
                    data == 1 ?
                        <div className="d-flex justify-content-between">
                            <Button type="primary" onClick={() => {handleValidate(2, x.assign_for, x, 2)}}>Xác nhận tư vấn</Button>
                        </div>
                    : 
                        <div className={styles.tagStatus}>
                            <span style={{ background: statusLead[index].background, color: statusLead[index].color }}>{statusLead[index].label}</span>
                        </div>
                    
 
                )
            },
        },
    ];

    const handleValidate = (status, staff, dataA, type) => {
        let text = ""
        if (type === 1) {
            if (staff === 0) return false

            let index = _.findIndex(listStaff, function(o) { return o.id == staff; });
            text = "Chuyển khách cho " + listStaff[index].name
        }
        if (type === 2) text = "Đã tư vấn cho khách " + dataA.customer_name
        setContent(text)
        setTitle("Xác nhận tư vấn")

        let dataLead = {
            ...dataA,
            status: status,
            assign_for: staff
        }
        setDataSelect({...dataLead})
        setIsModalOpen(true)
    }

    const onChangeStatus = (e) => {
        setPage(1)
        setLimit(10)
        setStatus(e)
    }
    const debounced = useDebouncedCallback(
        (value, type) => {
            if (type == 1) {
                setNameFetch(value)
            } else {
                setPhoneFetch(value)
            }
        },
        1000
    );
    const onChangeName = (e) => {
        debounced(e.target.value, 1)
        setName(e.target.value)
    }
    const onChangePhone = (e) => {
        debounced(e.target.value, 2)
        setPhone(e.target.value)
    }
    const onChangeDate = (x, y) => {
        if (y[0] != "") {
            setStartDate(y[0])
            setEnDate(y[1])
        }
    }
    const handleChangePage = (page, pageSize) => {
        setPage(page)
        setLimit(pageSize)
    }
    const cancelSearch = async () => {
        setPage(1)
        setLimit(10)
        setName("")
        setPhone("")
        setStatus(statusLead[0].value)
        setStartDate(moment(new Date(moment().startOf('week'))).format('YYYY-MM-DD'))
        setEnDate(moment(new Date()).format('YYYY-MM-DD'))
        setNameFetch("")
        setPhoneFetch("")
    }
    const updateLead = async () => {
        try {
            setIsLoading(true)

            const rs = await axiosService('api/lead-consulting-website/update-lead', "POST", dataSelect)
            if (rs.data.code === 200) {
                setIsModalOpen(false)
                setReload(true)
                message.success("Xác nhận thành công")
            } else {
                message.error(rs?.data?.message ?? "Có lỗi xảy ra")
            }
            
            setIsModalOpen(false)
            setIsLoading(false)
            
        } catch (error) {
            console.error(error)
            message.error("Có lỗi xảy ra")
        }
    };
    const getDataLead = async () => {
        try {
            const res = await axiosService(`api/lead-consulting-website/get-all?limit=${limit}&page=${page}&phone=${phoneFetch}&customer_name=${nameFetch}&status=${status}&startDate=${startDate}&endDate=${endDate}`, "GET")
            if (res.data.success) {
                let data = res.data.data
                setList(data.results)
                setPage(data.pagination.page)
                setLimit(data.pagination.pageSize)
                setTotal(data.pagination.total)
                setReload(false)
                setIsLoading(false)
            } else {
                message.error("Có lỗi xảy ra")
            }
        } catch (error) {
            console.error(error)
            message.error("Có lỗi xảy ra")
        }
    }
    const getStaff = async () => {
        try {
            const rs = await axiosService("api/users/role", "POST", {role: [5]})
            const { data } = rs
            if (data.code === 200) {
                let list = []
                data.data.map(x => {
                    let item = {
                        id: x.id,
                        name: x.name,
                        disable: false
                    }
                    if (x.soft_delete || x.status === 2) item.disable = true

                    list.push(item)
                })
                list = _.sortBy(list, [function (o) { return o.disable; }]);
                list.unshift({ name: "Chọn nhân viên", id: 0 })
                
                setListStaff([...list])
                setIsLoading(false)
            }
        } catch (error) {
            console.error(error)
            setIsLoading(true)
        }
    }
    useEffect(async () => {
        getStaff()
    }, [])
    useEffect(() => {
        setIsLoading(true)
        getDataLead()
    }, [limit, page, startDate, endDate, phoneFetch, nameFetch, status, reload])

    return (
        <Spin size="large" spinning={isLoading} >
            <Modal title={title} open={isModalOpen} onOk={updateLead} onCancel={() => {setIsModalOpen(false)}}>
                <p>{content}</p>
            </Modal>
            <Row className="pt-2 pl-5 pr-5 m-0">
                <div style={{ width: "100%" }}>
                    <h5 className="text-center">Danh sách đăng ký nhận tư vấn</h5>
                </div>
            </Row>
            <Row className={`pt-2 pb-3 ${styles.background}`}>
                <Col>
                    <div>
                        <span className="ml-1">Tên khách hàng: </span>
                        <Input placeholder="Nhập tên khách hàng"
                            value={name}
                            onChange={onChangeName} allowClear
                        />
                    </div>
                </Col>
                <Col>
                    <div>
                        <span className="ml-1">Số điện thoại:</span>
                        <Input onChange={onChangePhone} placeholder="Nhập số điện thoại khách hàng" allowClear value={phone} />
                    </div>
                </Col>
                <Col>
                    <span className="ml-1">Trạng thái:</span>
                    <br></br>
                    <Select
                        showSearch
                        placeholder="Chọn một trạng thái"
                        optionFilterProp="children"
                        value={status}
                        className="w-100"
                        onChange={onChangeStatus}
                        filterOption={(input, option) => option.children.toLowerCase().includes(input.toLowerCase())}
                    >
                        <Option value="0">Tất cả</Option>
                        {statusLead.map((x, i) => (
                            <Option key={i+1} value={x.value}>{x.label}</Option>
                        ))}
                    </Select>
                </Col>
                <Col xs={3}>
                    <span className="ml-1">Chọn khoảng thời gian:</span>
                    <br></br>
                    <RangePicker
                        className="w-100"
                        onChange={onChangeDate}
                        ranges={
                            {
                                "Hôm nay": [moment(), moment()],
                                "Ngày mai": [moment().add(1, 'day'), moment().add(1, 'day')],
                                'Tuần này': [moment().startOf('isoWeek'), moment().endOf('isoWeek')],
                                'Tuần sau': [moment().add(1, 'weeks').startOf('isoWeek'), moment().add(1, 'weeks').endOf('isoWeek')],
                                'Tháng này': [moment().startOf('month'), moment().endOf('month')],
                                'Tháng sau': [moment().add(1, 'months').startOf('month'), moment().add(1, 'months').endOf('month')],
                            }
                        }
                        allowClear={false}
                        value={[moment(startDate, "YYYY-MM-DD"), moment(endDate, "YYYY-MM-DD")]} />
                </Col>
                <Col>
                    <span>{" "}</span>
                    <br />
                    <div className="d-flex justify-content-between">
                        <Button type="primary" size={"middle"} className="mr-2" onClick={() => {
                            cancelSearch(1, 10)
                        }}>
                            <span>Xoá tất cả</span>
                        </Button>
                    </div>
                </Col>
            </Row>
            <Row className={`pb-3 m-0 w-100 ${styles.background2}`}>
                <div className="d-flex justify-content-end w-100 pr-5 mt-2">
                    <p>Đang hiển thị <span style={{ color: "blue" }}>{list.length}</span> trên tổng số <span style={{ color: "red" }}>{total}</span> kết quả</p>
                </div>
                <Table
                    className="w-100 text-center"
                    pagination={false}
                    columns={columns} dataSource={list}
                />
                <div className={`d-flex justify-content-end w-100 mt-4 pt-2 pb-2 mr-5 ${styles.fixedPagination}`}>
                    <Pagination current={page} total={total} pageSize={limit} showSizeChanger showQuickJumper onChange={handleChangePage} />
                </div>
            </Row>
        </Spin>
    )
}